import React from 'react';
import SlideLayout, { SlideTitle, SlideContent } from '../components/SlideLayout';
import { BookOpen, FileText, Code, ExternalLink } from 'lucide-react';

const ResourcesSlide = () => {
  return (
    <SlideLayout maxWidth="6xl">
      <SlideTitle 
        subtitle="Further reading and resources for deep diving"
      >
        Recommended Resources
      </SlideTitle>
      
      <SlideContent>
        <div className="grid md:grid-cols-2 gap-6">
          {/* Books */}
          <div className="slide-card">
            <div className="flex items-center gap-2 mb-4">
              <BookOpen className="w-5 h-5 text-primary" />
              <h3 className="font-heading font-semibold text-foreground">Books</h3>
            </div>
            
            <div className="space-y-4">
              <div className="p-3 rounded-lg bg-muted/30 hover:bg-muted/50 transition-colors">
                <p className="font-medium text-foreground text-sm">"Build a Large Language Model From Scratch"</p>
                <p className="text-xs text-muted-foreground mt-1">Sebastian Raschka • Chapters 1-3, 5, 7</p>
              </div>
              <div className="p-3 rounded-lg bg-muted/30 hover:bg-muted/50 transition-colors">
                <p className="font-medium text-foreground text-sm">"Build a Reasoning Model From Scratch"</p>
                <p className="text-xs text-muted-foreground mt-1">Manning MEAP • RLVR and GRPO chapters</p>
              </div>
            </div>
          </div>
          
          {/* Papers */}
          <div className="slide-card">
            <div className="flex items-center gap-2 mb-4">
              <FileText className="w-5 h-5 text-secondary" />
              <h3 className="font-heading font-semibold text-foreground">Key Papers (2025)</h3>
            </div>
            
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-2">
                <span className="text-secondary">•</span>
                <span className="text-muted-foreground"><strong className="text-foreground">DeepSeek-R1:</strong> Incentivizing Reasoning in LLMs via RL</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-secondary">•</span>
                <span className="text-muted-foreground"><strong className="text-foreground">Kimi k1.5:</strong> Scaling RL with LLMs</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-secondary">•</span>
                <span className="text-muted-foreground"><strong className="text-foreground">Process Reward Models:</strong> Mathematical Reasoning</span>
              </div>
            </div>
          </div>
          
          {/* Online Resources */}
          <div className="slide-card">
            <div className="flex items-center gap-2 mb-4">
              <ExternalLink className="w-5 h-5 text-accent" />
              <h3 className="font-heading font-semibold text-foreground">Online Resources</h3>
            </div>
            
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-2">
                <span className="text-accent">•</span>
                <span className="text-muted-foreground">Sebastian Raschka's Substack: "State of LLMs 2025"</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-accent">•</span>
                <span className="text-muted-foreground">HuggingFace Models: /models?other=reasoning</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-accent">•</span>
                <span className="text-muted-foreground">Papers with Code: /task/reasoning</span>
              </div>
            </div>
          </div>
          
          {/* Tools */}
          <div className="slide-card">
            <div className="flex items-center gap-2 mb-4">
              <Code className="w-5 h-5 text-chart-4" />
              <h3 className="font-heading font-semibold text-foreground">Tools & Libraries</h3>
            </div>
            
            <div className="space-y-2 text-sm font-mono text-muted-foreground">
              <p className="text-chart-4"># Model serving</p>
              <p>pip install vllm transformers</p>
              <p className="text-chart-4 mt-3"># Network automation</p>
              <p>pip install netmiko napalm nornir</p>
            </div>
          </div>
        </div>
      </SlideContent>
    </SlideLayout>
  );
};

export default ResourcesSlide;
